import { Component } from '@angular/core';
import { MdbButtonComponent } from '../../utils/mdb-button/mdb-button.component';
import { CustomNotificationService } from '../../../services/utils/custom-notification.service';
import { MdbModalService } from 'mdb-angular-ui-kit/modal';
import { VehiclesTableComponent } from './vehicles-table/vehicles-table.component';
import { NewVehicleModalComponent } from './new-vehicle-modal/new-vehicle-modal.component';

@Component({
  selector: 'app-vehicles',
  imports: [
    MdbButtonComponent,
    VehiclesTableComponent
  ],
  templateUrl: './vehicles.component.html',
  styleUrl: './vehicles.component.scss',
})
export class VehiclesComponent {
  constructor(
    private notificationService: CustomNotificationService,
    private modalService: MdbModalService,
  ) {}

  openNewVehicleModal() {
    const modalRef = this.modalService.open(NewVehicleModalComponent, {
      modalClass: 'modal-lg',
      ignoreBackdropClick: true,
    });
    modalRef.onClose.subscribe((vehicle) => {
      if (!vehicle)
        return;

        this.notificationService.success('VEHICLES.SUCCESSFULLY_CREATED');
    });
  }
}
